<template>
  <div class="keyword_ideas_container">
    <div class="title_row">
      <div class="title-wrap">
        <div class="title">
          <h2>2. Pick 5-10 keywords</h2>
          <button
            class="btn btn_md primary_btn watch-video"
            @click="showHelpVideo = true"
          >
            <i class="video_icon" />
            <span>Watch help video</span>
          </button>
        </div>
        <div class="desc">
          Choose 5-10 keywords that you want your website to rank for. Add a seed keyword, competitor website,
          or even review your existing rankings and start to build a list of phrases.
          <br>
          Once you've completed onboarding, you can revisit this feature and further build your keyword list.
        </div>
      </div>
    </div>
    <div class="components_row">
      <div class="col-3 sidebar">
        <add-new-keyword :open="showAddKeyword" />
        <add-new-competitor
          v-if="canEditCompetitors"
          :open="showAddCompetitor"
        />
      </div>
      <div
        class="col-9"
        style="height: 100%; position: inherit;"
      >
        <keywords-table @updated-keywords="updateCurrentStep(nextStep)" />
      </div>
    </div>
  </div>
  <help-video-modal v-if="showHelpVideo" />
  <bulk-add-modal v-if="showBulkAddModal" />
</template>

<script>

import {mapActions, mapGetters} from 'vuex'
import AddNewKeyword from '../../../../views/keywords/components/ideas/includes/AddNewKeyword'
import AddNewCompetitor from '../../../../views/keywords/components/ideas/includes/AddNewCompetitor'
import KeywordsTable from '../../../../views/keywords/components/ideas/includes/KeywordsTable'
import HelpVideoModal from '../../../../views/keywords/components/ideas/modals/HelpVideoModal'
import BulkAddModal from "../../../../views/keywords/components/ideas/modals/BulkAddModal";

export default {
  components: {
    AddNewKeyword,
    AddNewCompetitor,
    KeywordsTable,
    HelpVideoModal,
    BulkAddModal,
  },
  data() {
    return {
      section: 'add-keyword',
      showAddKeyword: true,
      showAddCompetitor: true,
      showHelpVideo: false
    }
  },
  computed: {
    ...mapGetters('keywordIdeas', [
      'chosenKeywords',
      'previousTopics',
      'suggestions',
      'newChosenKeywords',
      'removeChosenKeywords',
      'showBulkAddModal',
    ]),
    ...mapGetters('onboarding', [
        'nextStep'
    ]),
    ...mapGetters('user', [
        'canEditCompetitors'
    ]),
  },
  mounted() {
    this.setOnboardingState(true);
    this.getUser();
    this.fetchData();
    window.onbeforeunload = () => {
      if (this.newChosenKeywords.length > 0 || this.removeChosenKeywords.length > 0) {
        return 'You have unsaved changes. Are you sure you want to leave?';
      }
    }
  },
  methods: {
    ...mapActions('keywordIdeas', [
        'fetchData',
        'setOnboardingState',
    ]),
    ...mapActions('user', [
        'getUser'
    ]),
    ...mapActions('onboarding', [
        'updateCurrentStep'
    ])
  }
}
</script>

<style lang="scss" scoped>
.keyword_ideas_container {
  height: 75vh;

  .title_row {
    height: 22%;

    .title-wrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-bottom: .5rem;

      .title {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;

        h2 {
          font-weight: 700;
          line-height: 1.25;
          letter-spacing: -0.042em;
          color: var(--primary-font-color);
          font-size: 2.5rem;
        }
      }

      .watch-video {
        margin: 0;
        height: 42px;
        display: inline-flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;

        span {
          font-weight: 400;
          line-height: 1.277;
          text-align: center;
          letter-spacing: -0.5px;
          text-transform: capitalize;
          font-size: 16px;
          margin: 0;
          padding: 0;
          outline: none;
          box-sizing: border-box;
          color: var(--white);
          margin-left: 10px;
        }

        .video_icon {
          width: 23px;
          height: 21px;
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          background-image: url("data:image/svg+xml,%3Csvg width='23' height='21' viewBox='0 0 23 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2.94745 5.1875H13.4738C14.1717 5.1875 14.8411 5.45089 15.3346 5.91973C15.8281 6.38857 16.1053 7.02446 16.1053 7.6875V15.1875C16.1053 15.3533 16.036 15.5122 15.9126 15.6294C15.7893 15.7467 15.6219 15.8125 15.4474 15.8125H4.92113C4.22319 15.8125 3.55384 15.5491 3.06032 15.0803C2.56681 14.6114 2.28955 13.9755 2.28955 13.3125V5.8125C2.28955 5.64674 2.35886 5.48777 2.48224 5.37056C2.60562 5.25335 2.77296 5.1875 2.94745 5.1875V5.1875Z' stroke='white' stroke-width='1.6875' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M16.105 9.25L20.7102 6.75V14.25L16.105 11.75' stroke='white' stroke-width='1.6875' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
        }
      }

      .desc {
        font-size: 1rem;
        line-height: 1.625;
        letter-spacing: -0.015625em;
        color: var(--secondary-font-color);
      }
    }
  }

  .components_row {
    height: 80%;
    display: flex;
    flex: 1;
    margin: 0 -15px;
  }
  
  .sidebar {
    height: 100%;
    overflow-y: scroll;
  }

  .sidebar::-webkit-scrollbar {
    display: none;
  }
}
</style>
